import { useRef, useState, useEffect } from 'react'
import { TextField, Button, Typography, Stack, Grid, IconButton } from '@mui/material'
import { AddCircleRounded } from '@mui/icons-material'
import { apiPut, apiGet } from '../Api_Functions'
import SmartDatePicker from '../smartDatePicker/Index'
import { SmartDialog } from '../utilities/SmartDialog'
import { useSmartTranslation } from '../../generic/hooks/useSmartTranslation'
import SmartSelect from '../smartSelect/SmartSelect'

const AddElement = (props) => {
  const { endpoint, parameter, title, referenceName, disable, onAlert } = props
  const [showDialog, setShowDialog] = useState(false)
  const quantity = useRef(1)
  const entryDate = useRef(new Date())
  const { t_ } = useSmartTranslation()
  const [rawMaterialStatuses, setRawMaterialStatuses] = useState([])
  const [status, setStatus] = useState(null)
  const rawMaterial = 'rawMaterials'

  useEffect(() => {
    if (endpoint === rawMaterial) {
      apiGet('rawMaterials/statuses').then(data => {
        setRawMaterialStatuses(data || [])
        setStatus(data && data.length > 0 ? data[0] : null)
      })
    }
  }, [endpoint])

  const updateQuantity = () => {
    if (!endpoint) return

    if (quantity.current <= 0) {
      return
    }

    if (isNaN(entryDate.current)) {
      // Date is not valid
      return
    }

    if (endpoint === rawMaterial && (status === null || status === '' || status === undefined)) {
      return
    }

    setShowDialog(false)
    if (status == null) {
      apiPut(endpoint + '/' + parameter + '/' + quantity.current + '/' + entryDate.current)
        .catch(err => {
          onAlert({
            title: t_('Error updating quantity'),
            severity: 'error',
            message: t_('Quantity could not be updated') + ': ' + err
          })
        })
      return
    }
    apiPut(endpoint + '/' + parameter + '/' + quantity.current + '/' + entryDate.current + '/' + status, {})
      .catch(err => {
        onAlert({
          title: t_('Error updating quantity'),
          severity: 'error',
          message: t_('Quantity could not be updated') + ': ' + err
        })
      })
    quantity.current = 1
  }

  function onClickFunction () {
    entryDate.current = new Date()
    setShowDialog(true)
  }

  return (
    <div>
      <SmartDialog
        setOpen={showDialog}
        acceptCallback={updateQuantity}
        cancelCallback={() => setShowDialog(false)}
        title={{
          icon: <AddCircleRounded color='primary' sx={{ fontSize: '1.5em' }} />,
          render:
  <Stack
    direction='row'
    justifyContent='center'
    alignItems='center'
  >
    <Typography variant='h6' color='primary'> {referenceName}</Typography>
  </Stack>
        }}
        renderComponent={
          <>
            <Grid container justifyContent='center' sx={{ padding: (theme) => theme.spacing(2) }}>
              <Grid item xs={2}>
                <TextField
                  error={quantity.current <= 0}
                  label={t_('Quantity')} defaultValue={1} type='number' onChange={(event) => { quantity.current = event.target.value }}
                />
              </Grid>
              <Grid item xs={6}>
                <SmartDatePicker resultDate={entryDate} />
              </Grid>
              {endpoint === rawMaterial
                ? (
                  <Grid item xs={4}>
                    <SmartSelect
                      value={status}
                      selectableOptions={rawMaterialStatuses}
                      onChange={(newValue) => setStatus(newValue)}
                      label={t_('Status')}
                    />
                  </Grid>
                  )
                : null}
            </Grid>
          </>
        }
      />
      {title === undefined
        ? (
          <IconButton
            color='primary'
            onClick={onClickFunction}
            disabled={disable}
          >
            <AddCircleRounded />
          </IconButton>
          )
        : (
          <Button
            sx={{ borderColor: 'transparent' }}
            color='primary'
            variant='outlined'
            onClick={onClickFunction}
            disabled={disable}
          >
            <AddCircleRounded style={{ fontSize: '1.2em' }} />
            <Typography style={{ marginLeft: '0.4em', fontSize: '0.875rem' }}>{title}</Typography>
          </Button>)}
    </div>
  )
}

export default AddElement
